import {
  FluentProvider,
  FluentProviderProps,
  PartialTheme,
  webDarkTheme,
  webLightTheme
} from "@fluentui/react-components";

export interface FluentProviderCustomProps {
  rcName?: string;
  theme?: string;
}

const FluentProviderCustom = (props: FluentProviderProps & FluentProviderCustomProps) => {
  const renderTheme: PartialTheme =
    props.theme === "dark" ? webDarkTheme : webLightTheme;
  return <FluentProvider
    {...props}
    theme={
    props.theme === "dark"
      ? webDarkTheme
      : {
        ...renderTheme,
        colorCompoundBrandStroke: "rgb(70, 101, 136)",
        colorCompoundBrandStrokeHover: "rgb(21, 51, 89)",
        colorCompoundBrandForeground1: "rgb(70, 101, 136)",
        colorNeutralForeground2BrandHover: "rgb(21, 51, 89)",
        colorTransparentBackgroundHover: "rgb(21, 51, 89)",
        colorCompoundBrandBackground: "rgb(70, 101, 136)",
        colorCompoundBrandBackgroundHover: "rgb(21, 51, 89)",
      }
  }></FluentProvider>
};

export default FluentProviderCustom;